import { useCallback } from "react";
import useUserQuery from "./useUserQuery";

const useUserRepository = (forceRefresh = true) => {
	const query = useUserQuery(forceRefresh);
	const findUser = useCallback(() => query.refetch(), [query]);
	return {
		findUser,
		isInitialLoadingUser: query.isInitialLoading,
		user: query.data,
	};
};

export default useUserRepository;
